/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Automatically_Drafts_ReplieInputs */

const en_ai_automatically_drafts_replie = /** @type {(inputs: Ai_Automatically_Drafts_ReplieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI automatically drafts replies to new inquiries`)
};

const es_ai_automatically_drafts_replie = /** @type {(inputs: Ai_Automatically_Drafts_ReplieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La IA redacta automáticamente respuestas a nuevas consultas`)
};

const fr_ai_automatically_drafts_replie = /** @type {(inputs: Ai_Automatically_Drafts_ReplieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'IA rédige automatiquement des réponses aux nouvelles demandes`)
};

const de_ai_automatically_drafts_replie = /** @type {(inputs: Ai_Automatically_Drafts_ReplieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die KI entwirft automatisch Antworten auf neue Anfragen`)
};

const ja_ai_automatically_drafts_replie = /** @type {(inputs: Ai_Automatically_Drafts_ReplieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIが新規問い合わせに対する返信を自動で下書きします`)
};

const zh_ai_automatically_drafts_replie = /** @type {(inputs: Ai_Automatically_Drafts_ReplieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 会自动为新的咨询起草回复`)
};

const ar_ai_automatically_drafts_replie = /** @type {(inputs: Ai_Automatically_Drafts_ReplieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يقوم الذكاء الاصطناعي بصياغة ردود على الاستفسارات الجديدة تلقائياً`)
};

const id_ai_automatically_drafts_replie = /** @type {(inputs: Ai_Automatically_Drafts_ReplieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI secara otomatis membuat draf balasan untuk pertanyaan baru`)
};

const it_ai_automatically_drafts_replie = /** @type {(inputs: Ai_Automatically_Drafts_ReplieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'IA redige automaticamente le risposte alle nuove richieste`)
};

const ru_ai_automatically_drafts_replie = /** @type {(inputs: Ai_Automatically_Drafts_ReplieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ИИ автоматически составляет ответы на новые запросы`)
};

const pt_ai_automatically_drafts_replie = /** @type {(inputs: Ai_Automatically_Drafts_ReplieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A IA faz rascunhos de respostas automaticamente para novas consultas`)
};

const ko_ai_automatically_drafts_replie = /** @type {(inputs: Ai_Automatically_Drafts_ReplieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI가 새로운 문의에 대한 답변을 자동으로 초안 작성합니다`)
};

/**
* | output |
* | --- |
* | "AI automatically drafts replies to new inquiries" |
*
* @param {Ai_Automatically_Drafts_ReplieInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ai_automatically_drafts_replie = /** @type {((inputs?: Ai_Automatically_Drafts_ReplieInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Automatically_Drafts_ReplieInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ai_automatically_drafts_replie(inputs)
	if (locale === "es") return es_ai_automatically_drafts_replie(inputs)
	if (locale === "fr") return fr_ai_automatically_drafts_replie(inputs)
	if (locale === "de") return de_ai_automatically_drafts_replie(inputs)
	if (locale === "ja") return ja_ai_automatically_drafts_replie(inputs)
	if (locale === "zh") return zh_ai_automatically_drafts_replie(inputs)
	if (locale === "ar") return ar_ai_automatically_drafts_replie(inputs)
	if (locale === "id") return id_ai_automatically_drafts_replie(inputs)
	if (locale === "it") return it_ai_automatically_drafts_replie(inputs)
	if (locale === "ru") return ru_ai_automatically_drafts_replie(inputs)
	if (locale === "pt") return pt_ai_automatically_drafts_replie(inputs)
	return ko_ai_automatically_drafts_replie(inputs)
});